<script lang="ts">
  import Locale from "../locale.svelte";
  import Sprite from "../sprite.svelte";

  export let offset = 0;
  export let active = false;

  function beginPlacement() {
    active = true;
  }

  function disengage() {
    if (active != true) {
      return;
    }

    active = false;
  }
</script>

<svelte:window on:click|capture={disengage} on:touchend={disengage} />

<menu class:active style="--fab-extra-offset: {offset}px;">
  <button class="Locate" class:active type="button" on:click={beginPlacement}>
    {#if active}
      <span class="Label">
        <Locale label="maps.debug.tapLocate" />
      </span>
    {:else}
      <Sprite icon="icon-gps-on" size={24} />

      <span class="Label">
        <Locale label="maps.debug.setLocation" />
      </span>
    {/if}
  </button>
</menu>

<style>
  menu {
    --fab-size: 48px;
    bottom: calc(var(--fab-position, 0px) + var(--fab-extra-offset, 0px));
    padding: 0 0 var(--fab-offset, 0px);
    position: fixed;
    right: 10px;
    display: flex;
    flex-direction: column;
    margin: 0;
    z-index: 1;
    transition: 0.15s padding;
    visibility: var(--controls-visibility, visible);
  }

  menu.active {
    left: 10px;
    color: white;
  }

  menu button {
    background: white;
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.12),
      0 2px 5px rgba(0, 0, 0, 0.12);
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: var(--fab-size);
    border-radius: var(--fab-size);
    color: rgba(0, 0, 0, 0.88);
    line-height: 1;
    padding: 0 12px;
  }

  button:disabled {
    opacity: 0.5;
  }

  button:focus {
    outline: none;
  }

  button.active {
    background: black;
    color: white;
    width: 100%;
    border-radius: var(--border-radius-small);
  }

  .Label {
    margin-left: 8px;
    text-transform: none;
    letter-spacing: 0;
    font-size: 12px;
  }
</style>
